export default __webpack_public_path__ + "static/media/ISMO CLASS-1 EXAM PATTERN 2025.815a1132.pdf";